import { authHeader, handleResponse } from "../helpers";
export const DispatchRptService = {
  fetchDispatchData,
  GetDispatchToPrint
};

async function fetchDispatchData(data) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(data)
  };

  const response = await fetch(
    `${process.env.REACT_APP_API_URL}DispatchRpt/GetDispatchReport`,
    requestOptions
  );
  return handleResponse(response);
}

async function GetDispatchToPrint(data) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(data)
  };

  const response = await fetch(
    `${process.env.REACT_APP_API_URL}DispatchRpt/GetDispatchToPrint`,
    requestOptions
  );
  return handleResponse(response);
}
